<template>
  
    <div>
      <!--ROW5-->
      <!-- Asociaciones -->
    <v-layout  align-center justify-space-around row wrap >
      <v-flex class="" xs8 sm8 md10 lg10>
        <p class="title_foot">{{row1_text1}}</p>
        <div class="hidden-md-and-up"><br></div>
        <v-layout align-center justify-space-around >               
        <v-flex style="padding:4vw" xs9 sm9 md5 lg5>
          <v-img
              src="logos_2.png"
            />                     
        </v-flex>
      
        
        </v-layout>
      </v-flex>
    </v-layout>

   <!--ROW6-->
    <v-layout class="hidden-sm-and-down" justify-center row wrap style="background-color:#0F3072">
      <v-flex style="paddin:3vw" xs12 sm12 md10 lg10 class="md_screen">
        <v-layout justify-center>
        <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
          <br><br><v-img src="Lalabum-logohorizontal20080.png" width="180px"></v-img>

        </v-flex>
        <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
          <a class="linkfooter" href="https://api.whatsapp.com/send?phone=+526692666060" target="_blank">
            <p slot="badge" class="text-footer" >{{row2_text1}}</p>  
          </a>
          <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/avisodeprivacidad.html" target="_blank">
            <p style="margin-top:-18%" class="text-footer" >{{row2_text2}}</p>  
          </a>
          <!--<a class="linkfooter" href="https://www.lalabumapp.com/privacidad/terminosycondiciones.html" target="_blank">
            <p style="margin-top:-18%" class="text-footer" >{{row2_text3}}</p>  
          </a>-->
        </v-flex>
        <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
          <p class="text-footer" style="font-weight:700" >{{row2_text4}}</p>
          <p style="margin-top:-18%" class="text-footer" ><v-icon color="white">email</v-icon> {{row2_text5}}</p>
          <p style="margin-top:-18%" class="text-footer" ><v-icon color="white">local_phone</v-icon> {{row2_text6}}</p>
        </v-flex>
        </v-layout>
      </v-flex>
      
    </v-layout>

     <!-- ROW6 MOBILE -->
    <v-layout row wrap style="background-color:#0F3072; margin-bottom:-2px" class="hidden-md-and-up" justify-center>
      <v-flex class="pa-4" xs12 sm12 md10 lg10 >
       <v-img src="Lalabum-logohorizontal20080.png" width="180px" style="margin-left:25%"></v-img>
        <v-layout justify-center style="margin-top:6%">
        <v-flex class="tools" style="padding:3vw" xs8 sm8 md3 lg3>
            <a class="linkfooter" href="https://api.whatsapp.com/send?phone=+526692666060" target="_blank">
            <p slot="badge" class="text-center text-guia" style="font-size:4.5vw; text-align:center; color:white">{{row2_text1}}</p>          
            </a>
            <!-- Contacto -->


        </v-flex>
        </v-layout>
        <v-layout justify-center >
        <v-flex class="tools" style="padding:3.5vw" xs8 sm8 md3 lg3>
          <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/avisodeprivacidad.html">
            <p class="text-center text-guia" style="font-size:4.5vw; text-align:center; color:white; margin-top:-15%">{{row2_text2}}</p>
          </a>
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <!--<v-flex class="tools" style="padding:3.5vw" xs10 sm10 md lg3>
          <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/terminosycondiciones.html">
            <p class="text-center text-guia" style="font-size:4.5vw; text-align:center;color:white;margin-top:-15%">{{row2_text3}}</p>                      
          </a>
        </v-flex>-->
        </v-layout>
        <v-layout justify-center>
          <v-flex style="padding:4vw" xs9 sm9 md4 lg4>
          <p class="text-footer" style="font-weight:700; text-align:center;font-size:4.5vw; margin-top:-15% " >{{row2_text4}}</p>
          <p style="margin-top:-8%; font-size:4vw; text-align:center; font-weight:400" class="text-footer" ><v-icon color="white">email</v-icon> {{row2_text5}}</p>
          <p style="margin-top:-8%; font-size:4vw; text-align:center; font-weight:400" class="text-footer" ><v-icon color="white">local_phone</v-icon> {{row2_text6}}</p>
        </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

<!--ROW7-->
    <v-layout justify-center row wrap style="background-color:#0F3072">
      <v-flex mb-2 xs12 sm12 md10 lg10  class="md_screen">
        <v-layout justify-center>
        <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
          <a href="https://www.instagram.com/lalabumapp/?utm_source=hs_email&utm_source=hs_email&utm_source=hs_email&utm_medium=email&utm_medium=email&utm_medium=email&utm_content=68200061&utm_content=68907708&utm_content=69489615&_hsenc=p2ANqtz-_H4zcIa1GZd5c-UejUrAiSV-54nEUL0zfGOTmd6ow9DhP5i0ikqpmd9TXApNTF0xu6SQdo7Ts89mo22kYF2mYPpc5Kbw&_hsenc=p2ANqtz-8CT6I3_7VUYmWvpYi6pxhIWfuNC4v4dW7v3u9DcLuFemCG40HJ--UIp8qIRATC4Nj9D2cQlcgtQyiv4qCDwatfw15U_Q&_hsmi=68200061&_hsmi=68907708&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
            <v-img v-if=true src="instagram.png">
                </v-img>
          </a>
        </v-flex>
        <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
          <a href="https://www.facebook.com/lalabumapp/?utm_source=hs_email&utm_medium=email&utm_content=69489615&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
            <v-img v-if=true src="facebook.png">
                </v-img>
          </a>
        </v-flex>
        <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
          <a href="https://open.spotify.com/album/4Hie83iGijeoq9u9CN9WHF?utm_source=hs_email&utm_medium=email&utm_content=69489615&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
            <v-img v-if=true src="spotify.png">
                </v-img>
          </a>
        </v-flex>
        <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
          <a href="https://www.youtube.com/channel/UCuNE-4L5V5PEnHfqqft24mw?utm_source=hs_email&utm_medium=email&utm_content=69489615&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
            <v-img v-if=true src="youtube.png">
                </v-img>
          </a>
        </v-flex>
        </v-layout>
        
      </v-flex>
    </v-layout>
    </div>

</template>


<script>
export default {
  data() {
    if(localStorage.getItem('language')===null||localStorage.getItem('language')==""){
        var userLang = navigator.languages[navigator.languages.length-1] || navigator.userLanguage;
        localStorage.setItem('language',userLang);      
      }
    let language=localStorage.getItem('language');
      
    //let language=localStorage.getItem('language');
      if (language=='es') 
      {
        return{
          dialogcontact:false,
          name:'',
          email:'',
          select:'',
          school:'',
          Message:'',
          row1_text1:'Asociaciones que confían en Lalabum',
          row2_text1:'Contacto',
          row2_text2:'Aviso de privacidad',
          row2_text3:'Términos y Condiciones',
          row2_text4:'Servicio al cliente',
          row2_text5:'info@lalabumapp.com',
          row2_text6:'669 266 6060'
        }
      } else {
        return{
          dialogcontact:false,
          name:'',
          email:'',
          select:'',
          school:'',
          Message:'',
          row1_text1:'Associations that trust Lalabum',
          row2_text1:'Contact',
          row2_text2:'Notice of privacy',
          row2_text3:'Terms and conditions',
          row2_text4:'Support',
          row2_text5:'info@lalabumapp.com',
          row2_text6:'018008909662',
        }
      }
      
    }

    /*data: () => ({
      dialog: false
    }),
    methods:
    {
      
    }*/
  }
</script>


<style>
/* PC */
@media screen and (min-width: 960px) {
  .md_screen {
   margin-top: -60px;
  }
  .md_screen p{
   font-size: 1.3vw;
  }

  .title_foot{
    font-size: 1.3vw;
  }

  .text-footer{
    font-size: 1vw!important;
  }

  
}
/* ---- */

/* Movil */
@media screen and (max-width: 480px) {
  .md_screen p{
   font-size: 2.5vw;
  }

  .title_foot{
    font-size: 4vw!important;
  }
}
/* ---- */

/* Asociaciones*/

.title_foot{
  color: gray;
  font-weight: 200; 
  padding-top: 2vw;
  text-align: center;
  font-family: 'Poppins', sans-serif;
}


.linkfooter{
  text-decoration: none;
}

.text-footer{
  color:white!important;
  font-family:  'Poppins', sans-serif;
  font-weight: 500;
  padding-top: 3vw;
  text-align: left;
}

</style>
